import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { firebaseAuth } from "src/hooks/use-firebase-app";

const rawBaseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_HOST_API,
    prepareHeaders: async (headers) => {
        const user = firebaseAuth.currentUser;

        if (user) {
            const accessToken = await user.getIdToken();
            headers.set('Authorization', `Bearer ${accessToken}`);
            console.log("Access Token: " + accessToken);
        }

        headers.set('Content-Type', 'application/json');

        return headers;
    },
    timeout: 30000
});

export const baseQuery = async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, api, extraOptions);

    if (result?.error) {
        const status = result.error.status;
        const errorText = typeof result.error.error === 'string' ? result.error.error.toLowerCase() : '';
        const isOffline = typeof navigator !== 'undefined' && !navigator.onLine;

        if (
            status === 'FETCH_ERROR' ||
            isOffline ||
            errorText.includes('failed to fetch') ||
            errorText.includes('network') ||
            errorText.includes('fetch')
        ) {
            result.error.error = 'Lost connection';
        }
    }

    return result;
};
